import PropTypes from "prop-types";
export default function Title({ title }) {
  return <div className="row-label">{`${title}`}</div>;
}
Title.propTypes = {
  title: PropTypes.string.isRequired,
};
